import React from 'react';
import './About.css';

const About = () => {
    return <section id="about" className="about-section">
        <div className="about-container">
            <div className="section-header">
                <h2>关于蓝英</h2>
                <p>了解蓝英科技的故事</p>
            </div>

            <div className="about-content-wrapper">
                {/* 左侧：公司介绍 */}
                <div className="about-text">
                    <h3>创新驱动未来 <span className="highlight">技术改变世界</span></h3>
                    <p className="about-description">
                        蓝英科技成立于2017年，是一家专注于企业数字化转型的技术创新型企业。
                        我们汇聚了业内顶尖的工程师、设计师和产品专家，致力于为客户提供最优质的技术解决方案。
                    </p>

                    <div className="about-features">
                        <div className="about-feature">
                            <div className="feature-icon">🎯</div>
                            <div className="feature-detail">
                                <h4>我们的使命</h4>
                                <p>通过技术创新，帮助企业提升效率、降低成本、创造价值</p>
                            </div>
                        </div>

                        <div className="about-feature">
                            <div className="feature-icon">💡</div>
                            <div className="feature-detail">
                                <h4>我们的愿景</h4>
                                <p>成为领先的数字化转型服务商，推动行业智能化发展</p>
                            </div>
                        </div>

                        <div className="about-feature">
                            <div className="feature-icon">🤝</div>
                            <div className="feature-detail">
                                <h4>我们的价值观</h4>
                                <p>客户至上、技术创新、诚信务实、合作共赢</p>
                            </div>
                        </div>
                    </div>

                    <div className="about-stats">
                        <div className="stat-item">
                            <span className="stat-number">500+</span>
                            <span className="stat-label">服务客户</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-number">50+</span>
                            <span className="stat-label">合作伙伴</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-number">99.9%</span>
                            <span className="stat-label">系统可用性</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-number">24/7</span>
                            <span className="stat-label">技术支持</span>
                        </div>
                    </div>
                </div>

                {/* 右侧：全新设计的团队图片区域 */}
                <div className="about-team">
                    {/* 主图 - 大尺寸团队照片 */}
                    <div className="team-main-image">
                        <img
                            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                            alt="核心团队"
                        />
                        <div className="team-main-overlay">
                            <span className="team-main-title">核心团队</span>
                            <span className="team-main-count">15+ 技术专家</span>
                        </div>
                    </div>

                    {/* 团队成员网格 */}
                    <div className="team-members">
                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="张明" />
                            </div>
                            <div className="member-info">
                                <h4>张明</h4>
                                <p>技术总监</p>
                            </div>
                        </div>

                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="李华" />
                            </div>
                            <div className="member-info">
                                <h4>李华</h4>
                                <p>产品总监</p>
                            </div>
                        </div>

                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="王伟" />
                            </div>
                            <div className="member-info">
                                <h4>廉娟</h4>
                                <p>UI设计师</p>
                            </div>
                        </div>

                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="陈静" />
                            </div>
                            <div className="member-info">
                                <h4>向琳</h4>
                                <p>产品总监</p>
                            </div>
                        </div>
                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="王伟" />
                            </div>
                            <div className="member-info">
                                <h4>王伟</h4>
                                <p>架构师</p>
                            </div>
                        </div>

                        <div className="team-member">
                            <div className="member-avatar">
                                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="陈静" />
                            </div>
                            <div className="member-info">
                                <h4>陈静</h4>
                                <p>设计总监</p>
                            </div>
                        </div>
                    </div>

                    {/* 团队数据统计 */}
                    <div className="team-stats">
                        <div className="team-stat">
                            <span className="team-stat-number">50+</span>
                            <span className="team-stat-label">技术人员</span>
                        </div>
                        <div className="team-stat">
                            <span className="team-stat-number">8年</span>
                            <span className="team-stat-label">平均经验</span>
                        </div>
                        <div className="team-stat">
                            <span className="team-stat-number">100+</span>
                            <span className="team-stat-label">成功项目</span>
                        </div>
                        <div className="team-stat">
                            <span className="team-stat-number">24/7</span>
                            <span className="team-stat-label">技术支持</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 发展历程 */}
            <div className="timeline-section">
                <h3>发展历程</h3>
                <div className="timeline">
                    <div className="timeline-item">
                        <div className="timeline-year">2017</div>
                        <div className="timeline-content">
                            <h4>公司成立</h4>
                            <p>在北京中关村正式成立</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-year">2019</div>
                        <div className="timeline-content">
                            <h4>业务拓展</h4>
                            <p>服务客户突破100家</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-year">2021</div>
                        <div className="timeline-content">
                            <h4>技术创新</h4>
                            <p>获得高新技术企业认证</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-year">2024</div>
                        <div className="timeline-content">
                            <h4>国际化布局</h4>
                            <p>业务走出中国，覆盖东南亚市场</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

export default About;